<template>
  <div v-html="qty"></div>
</template>

<script>
import { cbQtyText } from '@/utils';

export default {
  name: 'tdQtyRequested',
  props: ['row'],
  computed: {
    qty() {
      return cbQtyText(
        this.row.boxesRequested,
        0,
        this.row.skus,
        true,
        true,
        true
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdQtyRequested.vue